import { z } from "zod"
import { useLink } from "../../hooks" 


const breadcrumbSchema = z.object({
  data: z
    .array(
      z.object({
        slug: z.string().nonempty("Slug is required"), 
        title: z.string().nonempty("Title is required"), 
      })
    )
    .min(1, "Data must contain at least one breadcrumb"), 
  title: z.string().nonempty("Title is required"),
})



const generateBreadcrumbJsonLd = (data: { slug: string; title: string }[]) => {

    const origin = window.location.origin

  const pathSegments = window.location.pathname.split("/").filter(Boolean)
  let localePrefix = ""

  if (pathSegments.length > 1) {
    localePrefix = `/${pathSegments[0]}/${pathSegments[1]}`
  }

  const homeUrl = useLink("/")


const normalizeUrl = (slug: string) => {
  let cleanSlug = slug.replace(/^\/+|\/+$/g, "")

  if (localePrefix && !cleanSlug.startsWith(localePrefix.replace(/^\/+/, ""))) {
    cleanSlug = `${localePrefix.replace(/^\/+|\/+$/g, "")}/${cleanSlug}`
  }

  let url = cleanSlug ? `${origin}/${cleanSlug}` : `${origin}${localePrefix}`
  url = url.replace(/([^:]\/)\/+/g, "$1") 
  if (!url.endsWith("/")) url += "/"
  return url
}




  const lastSegment = pathSegments[pathSegments.length - 1]

  const contentfulData = data.filter(
    item => item.title.toLowerCase() !== "home" && item.slug !== ""
  )

  let updatedData = [{ slug: "", title: "Home" }, ...contentfulData]

  const lastTitleInData =
    updatedData[updatedData.length - 1]?.title?.toLowerCase()
  if (lastTitleInData !== lastSegment.toLowerCase()) {
    updatedData.push({ slug: pathSegments.join("/"), title: lastSegment })
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: updatedData.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
      item: item.slug === "" ? homeUrl : normalizeUrl(item.slug),
    })),
  }
}

export const useValidateBreadcrumb = (props: any) => {
  try {
    breadcrumbSchema.parse(props)

    const jsonLd = generateBreadcrumbJsonLd(props.data)

    return { isValid: true, error: null, jsonLd }
  } catch (err: any) {
    return { isValid: false, error: err.errors, jsonLd: null }
  }
}
